import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import Layout from "../../components/Layout";
import HeroSection from "../../components/HeroSection/HeroSection";
import AlternatingCards from "../../components/home/AlternatingCards/AlternatingCards";
import MenuComponent from "../../components/home/MenuComponent/MenuComponent";
import DiscoverUs from "../../components/home/DiscoverUs/DiscoverUs";

/*----- Hero Image Imports -----*/
import heroImage1 from "../../assets/images/great-hall/greatHall1.jpg";
import heroImage2 from "../../assets/images/crystal-hall/crystalHall1.jpg";
import heroImage3 from "../../assets/images/small-hall/smallHall1.jpg";
import heroImage4 from "../../assets/images/playroom/playroom1.jpg";
import heroImage5 from "../../assets/images/catering/catering1.jpg";

/*----- Great Hall Images Imports -----*/
import greatHallImage1 from "../../assets/images/great-hall/greatHall2.jpg";
import greatHallImage2 from "../../assets/images/great-hall/greatHall3.jpg";
import greatHallImage3 from "../../assets/images/great-hall/greatHall4.jpg";
import greatHallImage4 from "../../assets/images/great-hall/greatHall5.jpg";

/*----- Crystal Hall Images Imports -----*/
import crystalHallImage1 from "../../assets/images/crystal-hall/crystalHall2.jpg";
import crystalHallImage2 from "../../assets/images/crystal-hall/crystalHall3.jpg";
import crystalHallImage3 from "../../assets/images/crystal-hall/crystalHall4.jpg";
import crystalHallImage4 from "../../assets/images/crystal-hall/crystalHall5.jpg";

/*----- Small Hall Images Imports -----*/
import smallHallImage1 from "../../assets/images/small-hall/smallHall2.jpg";
import smallHallImage2 from "../../assets/images/small-hall/smallHall3.jpg";
import smallHallImage3 from "../../assets/images/small-hall/smallHall4.jpg";
import smallHallImage4 from "../../assets/images/small-hall/smallHall5.jpg";

/*----- Playroom Images Imports -----*/
import playroomImage1 from "../../assets/images/playroom/playroom2.jpg";
import playroomImage2 from "../../assets/images/playroom/playroom3.jpg";
import playroomImage3 from "../../assets/images/playroom/playroom4.jpg";
import playroomImage4 from "../../assets/images/playroom/playroom5.jpg";

export default function Home() {
  const { t } = useTranslation(["home", "links"]);

  const cardsData = [
    {
      title: t("great_hall_title"),
      description: t("great_hall_description"),
      buttonHref: "/great-hall",
      buttonText: t("great_hall_button"),
      image: [
        greatHallImage1,
        greatHallImage2,
        greatHallImage3,
        greatHallImage4,
      ],
    },
    {
      title: t("crystal_hall_title"),
      description: t("crystal_hall_description"),
      buttonHref: "/crystal-hall",
      buttonText: t("crystal_hall_button"),
      image: [
        crystalHallImage1,
        crystalHallImage2,
        crystalHallImage3,
        crystalHallImage4,
      ],
    },
    {
      title: t("small_hall_title"),
      description: t("small_hall_description"),
      buttonHref: "/small-hall",
      buttonText: t("small_hall_button"),
      image: [
        smallHallImage1,
        smallHallImage2,
        smallHallImage3,
        smallHallImage4,
      ],
    },
    {
      title: t("playroom_title"),
      description: t("playroom_description"),
      buttonHref: "/playroom",
      buttonText: t("playroom_button"),
      image: [playroomImage1, playroomImage2, playroomImage3, playroomImage4],
    },
  ];
  return (
    <Layout>
      <Helmet>
        <title>Restoran Vidovdan</title>
        <meta
          name="description"
          content={
            "Otkrijte savršenu kombinaciju tradicije i modernih ukusa u restoranu Vidovdan. Bilo da ste tu zbog porodičnog ručka, romatične večere ili posebne proslave, svaka poseta je novo iskustvo"
          }
        />
        <link rel="canonical" href={"https://vidovdanrestoran.rs"} />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={"Restoran Vidovdan"} />
        <meta
          property="og:description"
          content={
            "Otkrijte savršenu kombinaciju tradicije i modernih ukusa u restoranu Vidovdan. Bilo da ste tu zbog porodičnog ručka, romatične večere ili posebne proslave, svaka poseta je novo iskustvo"
          }
        />
        <meta property="og:image" content={heroImage1} />
        <meta property="og:url" content={"https://vidovdanrestoran.rs"} />
        <meta property="og:site_name" content="Vidovdan" />
        <meta property="og:locale" content="sr_RS" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={"Restoran Vidovdan"} />
        <meta
          name="twitter:description"
          content={
            "Otkrijte savršenu kombinaciju tradicije i modernih ukusa u restoranu Vidovdan. Bilo da ste tu zbog porodičnog ručka, romatične večere ili posebne proslave, svaka poseta je novo iskustvo"
          }
        />
        <meta name="twitter:image" content={heroImage1} />
      </Helmet>
      <HeroSection
        title={t("hero_title")}
        subTitle={t("hero_subtitle")}
        images={[heroImage1, heroImage2, heroImage3, heroImage4, heroImage5]}
        description={t("hero_description")}
      />
      <AlternatingCards cards={cardsData} />
      <MenuComponent t={t} />
      <DiscoverUs t={t} />
    </Layout>
  );
}
